<template>
    <div class="container md:mt-24 mt-16">
        <div class="grid grid-cols-1 pb-8 text-center">
            <SectionTitleComponent :title="'Reviews'" />
        </div>

            <div class="grid grid-cols-1 relative overflow-hidden lg:px-8 px-3 py-5 rounded-xl shadow-lg dark:shadow-gray-700">
                <div class="tiny-single-item">

                    <div v-for="review of reviewStore.getReviews()" :key="review.id" class="relative">
                        <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px] mt-12 m-4 md:m-12 p-3">
                            <div class="lg:col-span-8 md:col-span-7">
                                <div class="md:text-start text-center relative z-1">
                                    <h3 class="text-xl md:text-3xl md:leading-normal leading-normal font-bold">{{ review.title }}</h3>
                                    <p class="text-zinc-700 max-w-2xl">{{ review.review }}</p>
                                </div>
                            </div>
                        </div>
        
                        <div class="absolute top-6 w-full md:w-auto md:left-14 text-center">
                            <span class="uil uil-star lg:text-[20px] text-xl text-amber-300 dark:text-white/5"></span><!--ltr:-rotate-45 rtl:rotate-45-->
                            <span class="uil uil-star lg:text-[20px] text-xl text-amber-300 dark:text-white/5"></span><!--ltr:-rotate-45 rtl:rotate-45-->
                            <span class="uil uil-star lg:text-[20px] text-xl text-amber-300 dark:text-white/5"></span><!--ltr:-rotate-45 rtl:rotate-45-->
                            <span class="uil uil-star lg:text-[20px] text-xl text-amber-300 dark:text-white/5"></span><!--ltr:-rotate-45 rtl:rotate-45-->
                            <span class="uil uil-star lg:text-[20px] text-xl text-amber-300 dark:text-white/5"></span><!--ltr:-rotate-45 rtl:rotate-45-->
                        </div>
        
                        <div class="absolute bottom-0 end-6 md:top-6 md:end-24">
                            <img src="../assets/images/logo-impuls-triangle-transparent.png" class="inline h-8 opacity-40 md:h-32 md:opacity-25" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script setup>
import { useReviewStore } from '@/stores/review';
import SectionTitleComponent from '@/components/SectionTitleComponent.vue';
import { tns } from 'tiny-slider/src/tiny-slider';
import { onMounted } from 'vue';

let reviewStore = useReviewStore();

onMounted(() => {
    tns({
        container: '.tiny-single-item',
        controls: true,
        mouseDrag: true,
        loop: true,
        rewind: false,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 7000,
        navPosition: "bottom",
        controlsText: ['<i class="text-xl mdi mdi-chevron-left "></i>', '<i class="text-xl mdi mdi-chevron-right"></i>'],
        nav: false,
        speed: 400,
        gutter: 0,
        responsive: {
            425: {
                items: 1
            },
        },
    });
});
</script>

<style lang="scss" scoped>
.tns-controls button:hover {
    background-color: rgb(252,211,77) !important
}

</style>